var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.$style.root, ( _obj = {}, _obj[_vm.$style.isActive] = _vm.active, _obj )],attrs:{"aria-expanded":_vm.active},on:{"click":function($event){$event.preventDefault();_vm.onClick()}}},[_c('span',{class:_vm.$style.label},[_vm._v("Menu")])])
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bee1f97c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/assets/js/objects/Burger/index.vue
// module id = +uKS
// module chunks = 2